module.exports = __webpack_public_path__ + "assets/img/service.19e8cca8.png";